import React, { useCallback, useState } from 'react';
import {
  bool,
  func,
  number,
  oneOfType,
  shape,
  string
} from 'prop-types';
import { Checkbox } from '@thd-olt-component-react/checkbox';
import './buybox-tooltip.scss';

const BuyboxTooltip = ({
  uom,
  uomPlural,
  unitsPerCase,
  caseUnitOfMeasure,
  pricing,
  addAdditional,
  quantity,
  onChange
}) => {
  const [additionalCoverage, changeAdditionalCoverage] = useState(addAdditional);

  const onAdditionalChange = (event) => {
    const includeExtra = event.target.checked;
    changeAdditionalCoverage(includeExtra);
    if (onChange) {
      onChange({ addAdditional: includeExtra, size: unitsPerCase });
    }
  };

  const fixedValue = (value) => {
    return (Math.round(value * 100) / 100).toFixed(2);
  };

  const numberWithComma = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const checkBulkPrice = () => {
    const bulkPrice = pricing?.alternate?.bulk?.value;
    const bulkPriceThresholdQty = pricing?.alternate?.bulk?.thresholdQuantity;
    const price = pricing?.value;
    if (bulkPrice && bulkPriceThresholdQty && quantity >= bulkPriceThresholdQty) {
      return bulkPrice;
    }

    return price;
  };

  const newPrice = checkBulkPrice(quantity, pricing);
  const totalPrice = +quantity * +newPrice;
  const totalCoverage = +quantity * +unitsPerCase;
  const updatedTotalPrice = fixedValue(totalPrice);
  const measureUnit = quantity && parseInt(quantity, 10) > 1 ? uomPlural : uom;
  return (
    <div className="pip-row calculator__output-box">
      <div className="col__7-12">
        <div className="calculator__output-large-text">{quantity} {measureUnit}</div>
        <div> will cover {fixedValue(totalCoverage)} {caseUnitOfMeasure}</div>
      </div>
      <div className="col__5-12 calculator__output-box--right">
        <div className="calculator__output-large-text"> ${numberWithComma(updatedTotalPrice)} </div>
        <div>Est. Total</div>
      </div>
      <Checkbox
        value="additional-coverage"
        id="additional-coverage"
        onChange={onAdditionalChange}
        checked={additionalCoverage}
      >
        Include an extra 10% to cover potential waste and breaks
      </Checkbox>
    </div>
  );
};

BuyboxTooltip.propTypes = {
  onChange: func,
  addAdditional: bool,
  uom: string,
  uomPlural: string,
  unitsPerCase: oneOfType([string, number]),
  caseUnitOfMeasure: string,
  pricing: shape({
    bulkPrice: number,
    bulkPriceThresholdQty: number,
    originalPrice: number,
    specialPrice: number
  }),
  quantity: oneOfType([string, number])
};

BuyboxTooltip.defaultProps = {
  onChange: null,
  addAdditional: true,
  uom: '',
  uomPlural: '',
  unitsPerCase: '',
  caseUnitOfMeasure: '',
  pricing: {},
  quantity: 1
};

export { BuyboxTooltip };
